// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingVoucherResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BillingVoucherApiResponse = {
	id: number;
	code: string;
	subscriptionAmount: number;
	permanentDiscountAmount: number;
	permanentDiscountPercent: number;
	frequency: number | null;
	nextInvoiceDiscountAmount: number;
	nextInvoiceDiscountPercent: number;
	nextPackage: string | null;
	businessUsedId: string | null;
	businessUseName: string | null;
	expiresAt: string | null;
};

export type BillingVoucher = {
	id: number;
	code: string;
	subscriptionAmount: number;
	permanentDiscountAmount: number;
	permanentDiscountPercent: number;
	frequency: number | null;
	nextInvoiceDiscountAmount: number;
	nextInvoiceDiscountPercent: number;
	nextPackage: string | null;
	businessUsedId: string | null;
	businessUseName: string | null;
	expiresAt: DateTime | null;
};

export function hydrateBillingVoucher(data: BillingVoucherApiResponse): BillingVoucher {
	return {
		...data,
		expiresAt: DateTimefromISO(data.expiresAt),
	};
}